import React from 'react';

const PageHeader = ({ title }) => {
	return (
		<div className={'page-header'}>
			<img src='../../../images/assessments/report/img/ReportGearsHeader.png' alt='' />
			<p className='title'>{title}</p>
		</div>
	);
};

export default PageHeader;
